<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog header=" {{ cellValue[0].toUpperCase() }}" [modal]="true" [(visible)]="dialogVisible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">

  <app-table [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="commentTable" [rows$]="comments$"
  [pageSize]="10"></app-table>
</p-dialog>

<div class="filter-dropdown-container-dis">

  <p-floatLabel>
    <p-autoComplete inputId="autoComplete1w" [(ngModel)]="selectedEmployee" [suggestions]="suggestions"
      placeholder="Employee" (completeMethod)="search($event)" (onSelect)="onEmployeeNameSelect($event)" />
      <label for="autoComplete1w">Employee</label>
    </p-floatLabel>

    <!-- <app-autocomplete [selectedValue]="selectedEmployee" [suggestions]="suggestions" (completeMethod)="search($event)"
  (onSelect)="onEmployeeNameSelect($event)" [inputlabel]="'Sched Date'"></app-autocomplete> -->

  <app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
    aria-label="Type" placeholder="Type" [showLabel]="false" label="Type" [showFloatingLabel]="true"
  customClass="districts-type-large-dropdown-adjustment"></app-dropdown>

  <app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
    (selectedValueChange)="onDistrictChange($event)" aria-label="District" placeholder="District" [showLabel]="false"
  label="District" [showFloatingLabel]="true" customClass="submitter-district-dropdown"></app-dropdown>


  <app-datepicker [(ngModel)]="selectedScheduledDate" (onSelectChange)="onScheduledDateChange($event)"
  [inputlabel]="'Sched Date'"></app-datepicker>

  <div>
    <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>

    <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
  </div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" (onAction2ButtonClicked)="onReloadClicked()" [actionButtons]="actionButtons"
  (onCellClicked)="onCellClicked($event)" [totalRecords]="totalRecords" [pageNumber]="pageNumber" [pageSize]="pageSize"
  (pageChanged)="handlePageChange($event)" (sortClicked)="onSortClicked($event)"
(onSearchText)="onSearchText($event)"></app-table>